import React, {useState} from "react";
import Modal from "react-responsive-modal";
import ModalViewChildContact from "./ModalViewChildContact";

const useModalViewChildContact = () =>
{
    const [dialog, setDialog]  = useState ({ openState: false, user: null })  ;

    const onClickActivate = ( user ) =>
    {
        setDialog ({ openState: true, user });
    }

    const onCloseModal = () =>
    {
        setDialog ({ openState: false, user: null });
    };

    const render = ( props ) =>
    {
        return (
            <Modal center focusTrapped={true} open={dialog.openState} closeOnOverlayClick={false} onClose={onCloseModal}>
                <ModalViewChildContact 
                    user={dialog.user} 
                    onClose={onCloseModal} 
                /> 
            </Modal>
        )
    }

    return [ render, onClickActivate ] ;
}

export default useModalViewChildContact ;
